import { COMPANY } from "../../lib/site";

export const Footer = () => {
  return (
    <footer className="border-t border-white/10 bg-background">
      <div className="mx-auto max-w-[1400px] px-5 py-16 md:px-10">
        <div className="flex flex-col justify-between gap-10 md:flex-row md:items-end">
          <div>
            <img src={COMPANY.logo} alt="Maddox Heating and Cooling" className="h-24 w-auto object-contain" />
            <p className="mt-4 max-w-xs text-sm text-muted-foreground">
              Heating &amp; cooling repair and maintenance. Serving Portland, OR
              and Vancouver, WA.
            </p>
          </div>
          <div className="font-mono-tech text-xs uppercase tracking-[0.15em] text-muted-foreground">
            <a href={COMPANY.phoneHref} className="block transition-colors hover:text-primary">
              {COMPANY.phone}
            </a>
            <a
              href={`mailto:${COMPANY.email}`}
              className="mt-2 block transition-colors hover:text-primary"
            >
              {COMPANY.email}
            </a>
            <p className="mt-2">{COMPANY.hours}</p>
          </div>
        </div>

        <div className="mt-14 overflow-hidden border-t border-white/10 pt-8">
          <div className="font-display text-[13vw] uppercase leading-none tracking-tight text-stroke md:text-[9rem]">
            Stay Comfortable
          </div>
        </div>

        <div className="mt-8 flex flex-col justify-between gap-2 font-mono-tech text-[10px] uppercase tracking-[0.2em] text-muted-foreground md:flex-row">
          <span>© {new Date().getFullYear()} Maddox Heating and Cooling</span>
          <span>Service only · Repairs &amp; maintenance · No installs</span>
        </div>
      </div>
    </footer>
  );
};
